import { render, staticRenderFns } from "./fileModal.vue?vue&type=template&id=3603648b&"
import script from "./fileModal.vue?vue&type=script&lang=js&"
export * from "./fileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports